import React, { useState, useEffect } from 'react';
import Topbar from '../../admin/layouts/Topbar';
import '../../superadmin/styles/pages/dashboard.css';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, InputAdornment, IconButton, Menu, Typography,
  Button,
  Tooltip,
} from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import view from '../../superadmin/assets/icons/view-icon.svg';
import edit from '../../superadmin/assets/icons/add-icon.svg';
import Addschool from '../../admin/components/Add_school';
import CircularProgress from '@mui/material/CircularProgress';
import instance from '../../utils/Api';
import Statusschool from '../../admin/components/Status_school';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../Contex'; // Adjust the path


const Schoollist = () => {
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { openStatusDialog, setOpenStatusDialog } = useGlobalContext();
  const { loading, setLoading } = useGlobalContext();
  const { anchorEl, setAnchorEl } = useGlobalContext();
  const { searchTerm, setSearchTerm } = useGlobalContext();
  const open = Boolean(anchorEl);
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const startIndex = (page) * rowsPerPage;
  const [transactions, setTransactions] = useState([]);
  const [addschools, setAddschools] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const navigate = useNavigate();
  const [studentCounts, setStudentCounts] = useState({});

  // const filteredSchools = transactions.filter((school) => {
  //   const searchTermLower = (searchTerm).toLowerCase();
  //   return (
  //     school?.Drivers?.name?.toLowerCase().includes(searchTermLower) ||
  //     school?.Drivers?.email?.toLowerCase().includes(searchTermLower) ||
  //     school?.Drivers?.mobile_no?.toLowerCase().includes(searchTermLower) ||
  //     school?.amount?.toString().includes(searchTermLower)
  //   );
  // });


  const handleChangePage = (event, newPage) => {
    console.log(newPage);
    
    setPage(newPage+1);
  };

  // const paginatedSchools = filteredSchools.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  console.log(transactions);
  
  const fetchSchools = async (page, rowsPerPage, searchTerm) => {
    const params = {
      page: page,
      limit: rowsPerPage,
      search: searchTerm,
    }
    try {
      const response = await instance.get('/Transactions/getTransactions', {params});
      // console.log(response);

      setTransactions(response.data);
    } catch (error) {
      console.error('Error fetching Schools:', error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchools(page, rowsPerPage, searchTerm);
  }, [page, rowsPerPage, searchTerm]);

  const handleEditClick = (school) => {
    setSelectedSchool(school);
    setOpenDialog(true);
  };

  const handleAddClick = () => {
    setSelectedSchool(null);
    setOpenDialog(true);
  };

  const handleStatusClick = (school) => {
    setSelectedSchool(school);
    setOpenStatusDialog(true);
  };



  return (
    <React.Fragment>
      <Topbar />
      {loading ? (
        <div className="loading">
          <CircularProgress />
        </div>
      ) : (<section className='main'>
        <div className='employees-text'>
          <Typography variant='h5'>Transactions</Typography>
          {/* <Button variant="outlined" onClick={handleAddClick}>Add School</Button> */}
        </div>
        <div className='employees-main'>
          <div className='employees-content'>
            <div className='search-options'>
              <TextField
                placeholder='Search'
                type='search'
                variant="outlined"
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value); setPage(1) }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div className='pagination-options table-pagination'>
              <div className='pagination-animation'></div>
              <TablePagination
                component="div"
                count={transactions?.total}
                rowsPerPage={rowsPerPage}
                page={page-1} // Adjust to be 0-based for MUI TablePagination
                onPageChange={handleChangePage}
                rowsPerPageOptions={[]}
                labelDisplayedRows={({ from, to, count }) => (
                  `${from} to ${to} of ${count !== -1 ? count : `more than ${to}`}`
                )}
              />
            </div>
          </div>
          <div className='employee-table'>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <div className='employee-name'>
                        S.NO
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name'>
                        Waste picker Name
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name'>
                        Email
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name' >
                        Mobile Number
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name' >
                        Item's Count
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name' >
                        Total Amount
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name' >
                        Payment Type
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name' >
                        Payment Status
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name-1' >
                        Action
                      </div>
                    </TableCell>
                    {/* <TableCell>
                      <div className='employee-name-1' >
                        Inventory
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className='employee-name-1' >
                        Transaction
                      </div>
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions?.data?.length > 0 ? (
                    transactions?.data?.map((transactions, index) => (
                      <TableRow tabIndex={-1} key={index + 1}>
                        <TableCell component="th" scope="row">
                          { index + 1}
                        </TableCell>
                        <TableCell align='left'>{transactions?.Drivers?.name} {transactions?.Drivers?.surname}</TableCell>
                        <TableCell align="left">{transactions?.Drivers?.email}</TableCell>
                        <TableCell align="left">{transactions?.Drivers?.mobile_no}</TableCell>
                        <TableCell align="left">{transactions?.products?.length}</TableCell>
                        <TableCell align="left">{transactions?.amount}</TableCell>
                        <TableCell align="left">{transactions?.payment_method}</TableCell>
                        <TableCell align="left">{transactions?.payment_status}</TableCell>
                        {/* <TableCell align='left'><span onClick={() => handleStatusClick(school)} style={{ backgroundColor: school.status === true ? 'rgb(229, 252, 240)' : 'rgb(255, 232, 232)', color: school.status === true ? 'rgb(0, 166, 81)' : 'rgb(235, 87, 87)', padding: "5px 7px", borderRadius: "3px", cursor: "pointer" }}><Tooltip title="Change Status" >{school.status === true ? "Active" : "Inactive"}</Tooltip></span> </TableCell> */}
                        {/* <TableCell align="center">
                          <span className='view' onClick={() => handleEditClick(school)}>
                            <Tooltip title="Update School"><img src={edit} alt="edit" /></Tooltip>
                          </span>
                        </TableCell> */}
                        <TableCell align="center">
                          <span className='view' onClick={() => navigate(`/admin/transaction/${transactions?._id}`)}>
                            <img src={view} alt="view" />
                            {/* <strong>{studentCounts[school._id] || 0}</strong> */}
                          </span>
                        </TableCell>
                        {/* <TableCell align="center">
                          <span className='view' onClick={() => navigate(`/admin/inventory?schoolId=${school._id}&schoolname=${school.School}`)}>
                            <Tooltip title="Inventory"><img src={view} alt="view" /></Tooltip>
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <span className='view' onClick={() => navigate(`/admin/transaction?schoolId=${school._id}&schoolname=${school.School}`)}>
                            <Tooltip title="Transaction"><img src={view} alt="view" /></Tooltip>
                          </span>
                        </TableCell> */}
                      </TableRow>
                    ))
                  ) :
                    (
                      <TableRow>
                        <TableCell colSpan={12} align="center">
                          <Typography>No Data Found</Typography>
                        </TableCell>
                      </TableRow>
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </section>
      )}
      <Addschool openDialog={openDialog} setOpenDialog={setOpenDialog} setAddschools={setAddschools} schools={selectedSchool} />
      <Statusschool open={openStatusDialog} handleClose={() => setOpenStatusDialog(false)} schools={selectedSchool} setAddschools={setAddschools} />
    </React.Fragment>
  )
}

export default Schoollist